import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ecee48e")

_pushScopeId("data-v-5ecee48e")
const _hoisted_1 = { class: "pantry-used-up-check-tag-item-view" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "pantry-used-up-check-tag-item",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick(...args)), ["stop"])),
    style: _ctx.styleBackground
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        class: "pantry-used-up-check-tag-item-check-icon",
        src: _ctx.getImage()
      }, null, 8, ["src"]),
      _createVNode("div", {
        class: "pantry-used-up-check-tag-item-label-text",
        style: { color: _ctx.getItemFontColor() }
      }, _toDisplayString(_ctx.label), 5)
    ])
  ], 4))
})